import { ProcurementApprovalsDataGet } from '../../../adapter';

export default async function HandleProcurementApprovalsDataGet(event) {
    // handle request
    const result = await ProcurementApprovalsDataGet(event);
    // console.log('data get reponse: ', result);

    return result;
}
